import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export default function Registro({ token }) {
  const [tokenValido, setTokenValido] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [completado, setCompletado] = useState(false);
  const [form, setForm] = useState({
    empresa_nombre: '', rfc: '', telefono: '',
    email: '', nombre_contacto: '', password: '', password2: '',
  });

  useEffect(() => { verificarToken(); }, []); // eslint-disable-line

  const verificarToken = async () => {
    const { data } = await supabase.from('onboarding_tokens').select('*').eq('token', token).single();
    if (!data || data.usado || new Date(data.expires_at) < new Date()) {
      setTokenValido(false);
    } else {
      setTokenValido(true);
    }
  };

  const registrar = async () => {
    setError('');
    if (!form.empresa_nombre || !form.email || !form.nombre_contacto || !form.password) {
      setError('Por favor completa todos los campos obligatorios.'); return;
    }
    if (form.password !== form.password2) { setError('Las contraseñas no coinciden.'); return; }
    if (form.password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    setLoading(true);
    try {
      const { data: empresa, error: errEmpresa } = await supabase.from('empresas')
        .insert({ nombre: form.empresa_nombre, rfc: form.rfc || null, telefono: form.telefono || null, email: form.email })
        .select().single();
      if (errEmpresa) throw new Error('Error al crear la empresa: ' + errEmpresa.message);
      const { data: authData, error: errAuth } = await supabase.auth.signUp({
        email: form.email, password: form.password,
        options: { data: { nombre: form.nombre_contacto } }
      });
      if (errAuth) throw new Error('Error al crear el usuario: ' + errAuth.message);
      const { error: errUsuario } = await supabase.from('usuarios').insert({
        id: authData.user.id, empresa_id: empresa.id,
        nombre: form.nombre_contacto, email: form.email, rol: 'admin', activo: true,
      });
      if (errUsuario) throw new Error('Error al registrar usuario: ' + errUsuario.message);
      await supabase.from('onboarding_tokens').update({ usado: true }).eq('token', token);
      setCompletado(true);
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  const s = {
    container: { minHeight: '100vh', background: '#0a0c10', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' },
    card: { background: '#111318', border: '1px solid #222730', borderRadius: '16px', padding: '48px 40px', width: '100%', maxWidth: '480px' },
    label: { fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' },
    input: { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '12px 14px', color: '#e8eaf0', fontSize: '14px', boxSizing: 'border-box', outline: 'none' },
    btn: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '8px', padding: '13px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', width: '100%' },
  };

  if (tokenValido === null) return <div style={s.container}><div style={{ fontSize: '14px', color: '#6b7280' }}>Verificando invitación...</div></div>;

  if (tokenValido === false) return (
    <div style={s.container}>
      <div style={{ ...s.card, textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#ef4444', marginBottom: '12px' }}>Link inválido o expirado</div>
        <div style={{ fontSize: '14px', color: '#6b7280', lineHeight: 1.6 }}>Este link ya fue usado o expiró. Contacta a LogiConnect para obtener uno nuevo.</div>
        <a href="https://wa.me/5218112345678" target="_blank" rel="noreferrer"
          style={{ display: 'inline-block', marginTop: '24px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', color: '#25d366', borderRadius: '8px', padding: '10px 20px', fontSize: '13px', fontWeight: '600', textDecoration: 'none' }}>
          💬 Contactar por WhatsApp
        </a>
      </div>
    </div>
  );

  if (completado) return (
    <div style={s.container}>
      <div style={{ ...s.card, textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>✅</div>
        <div style={{ fontSize: '20px', fontWeight: '700', color: '#00e5a0', marginBottom: '12px' }}>¡Cuenta creada!</div>
        <div style={{ fontSize: '14px', color: '#9ca3af', lineHeight: 1.7, marginBottom: '28px' }}>
          Tu empresa ha sido registrada. Revisa tu correo <strong style={{ color: '#e8eaf0' }}>{form.email}</strong> para confirmar tu cuenta.
        </div>
        <a href="/" style={{ display: 'block', background: '#00e5a0', color: '#000', borderRadius: '8px', padding: '13px', fontSize: '14px', fontWeight: '700', textDecoration: 'none', textAlign: 'center' }}>
          Ir a LogiConnect →
        </a>
      </div>
    </div>
  );

  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '26px', fontWeight: '800', marginBottom: '6px' }}>
            <span style={{ color: '#00e5a0' }}>LOGI</span><span style={{ color: '#fff' }}>CONNECT</span>
          </div>
          <div style={{ fontSize: '16px', fontWeight: '600', color: '#ffffff', marginBottom: '4px' }}>Crear tu cuenta</div>
          <div style={{ fontSize: '13px', color: '#6b7280' }}>Completa el formulario para activar tu plataforma</div>
        </div>
        {error && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '12px', marginBottom: '20px', fontSize: '13px', color: '#ef4444' }}>{error}</div>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600', borderBottom: '1px solid #222730', paddingBottom: '8px' }}>Datos de la Empresa</div>
          <div>
            <label style={s.label}>Nombre de la empresa *</label>
            <input value={form.empresa_nombre} onChange={e => setForm({...form, empresa_nombre: e.target.value})} placeholder="Logística del Norte S.A. de C.V." style={s.input} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <label style={s.label}>RFC</label>
              <input value={form.rfc} onChange={e => setForm({...form, rfc: e.target.value})} placeholder="LNO920301XX1" style={s.input} />
            </div>
            <div>
              <label style={s.label}>Teléfono</label>
              <input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="+52 81 0000 0000" style={s.input} />
            </div>
          </div>
          <div style={{ fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600', borderBottom: '1px solid #222730', paddingBottom: '8px', marginTop: '8px' }}>Tu Cuenta de Acceso</div>
          <div>
            <label style={s.label}>Tu nombre completo *</label>
            <input value={form.nombre_contacto} onChange={e => setForm({...form, nombre_contacto: e.target.value})} placeholder="Luis Eduardo Morales" style={s.input} />
          </div>
          <div>
            <label style={s.label}>Email *</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="tucorreo@empresa.com" style={s.input} />
          </div>
          <div>
            <label style={s.label}>Contraseña * (mínimo 8 caracteres)</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="••••••••" style={s.input} />
          </div>
          <div>
            <label style={s.label}>Confirmar contraseña *</label>
            <input type="password" value={form.password2} onChange={e => setForm({...form, password2: e.target.value})} placeholder="••••••••" style={s.input} />
          </div>
          <button onClick={registrar} disabled={loading} style={{ ...s.btn, marginTop: '8px', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Creando cuenta...' : 'Crear mi cuenta →'}
          </button>
          <div style={{ fontSize: '12px', color: '#6b7280', textAlign: 'center' }}>
            ¿Problemas? <a href="https://wa.me/5218112345678" target="_blank" rel="noreferrer" style={{ color: '#25d366', textDecoration: 'none' }}>Contáctanos por WhatsApp</a>
          </div>
        </div>
      </div>
    </div>
  );
}
